<template>
  <div class="container">
    <div class="common-header-wrap">
      <mt-header class="common-header" title="App Download">
        <mt-button icon="back" slot="left" @click="$router.push({name:'HomeIndex'})"></mt-button>
      </mt-header>
    </div>
    <div class="down_box">
      <dl>
        <dt>
          <img src="../../../assets/image/app_logo.png">
        </dt>
        <dd>Oubv</dd>
      </dl>
      <div class="down_btn">
        <a href="https://www.oubv.com/home/Download/?url=comoubven.apk" v-if="isShowAndroid">Download</a>
        <a href="https://apps.apple.com/cn/app/id1560297562" class="ios_btn" v-if="isShowIos">Download</a>
      </div>
    </div>
  </div>
</template>
<script>
import $ from 'jquery'

export default {
  name: 'HomeDown',
  data () {
    return {
      isIos: false,
      isAndroid: false
    }
  },
  created: function () {
    var u = navigator.userAgent
    var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1
    var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)

    if (isAndroid) {
      this.isAndroid = true
    }
    if (isIOS) {
      this.isIOS = true
    }
  },
  mounted () {
    if (this.isIOS) {
      $('.ios_btn')[0].click()
    }
  },
  computed: {
    isShowAndroid: function () {
      if (this.isAndroid) {
        return true
      }
    },
    isShowIos: function () {
      if (this.isIOS) {
        return true
      }
    }
  }
}
</script>

<style scoped>
.down_box{
  /*height: 100vh;
  background: #ffffff!important;*/
}
.down_box dl{
  text-align: center;
  padding-top: 5rem;
}
.down_box dl dt{
  text-align: center;
}
.down_box dl dt img{
  width: 4rem;
  height: 4rem;
  border-radius: .6rem;
}
.down_box dl dd{
  color: #000000;
  margin-top: .2rem;
}
.down_box .down_btn{
  margin-top: 2rem;
}
.down_box .down_btn a{
  display: block;
  width: 80%;
  height: 2rem;
  line-height: 2rem;
  margin: 0 auto;
  background-color: #ff9026;
  color: #ffffff;
  text-align: center;
  border-radius: .2rem;
  font-size: 18px !important;
}
</style>